// extracted by mini-css-extract-plugin
export default {"notice":"Notice_notice__Akl-G","warning":"Notice_warning__T2ISO"};